import { useEffect, useRef, useState, startTransition } from "react";

// Monte ses enfants quand l'utilisateur APPROCHE de la section
// (IntersectionObserver, marge 900px) ou, à défaut, pendant une période
// d'inactivité après le chargement (garantit le rendu pour le SEO et les
// utilisateurs qui ne scrollent pas), jamais dans le chemin d'une interaction.
export default function LazyMount({ children, rootMargin = "900px", idleDelay = 2500, minHeight = 480, placeholderId }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) return undefined;
    let obs;
    let idleId;
    let timerId;
    const reveal = () => startTransition(() => setShow(true));
    if ("IntersectionObserver" in window && ref.current) {
      obs = new IntersectionObserver(
        (entries) => { if (entries.some((e) => e.isIntersecting)) reveal(); },
        { rootMargin },
      );
      obs.observe(ref.current);
    }
    const onLoad = () => {
      if ("requestIdleCallback" in window) {
        idleId = window.requestIdleCallback(reveal, { timeout: idleDelay + 2000 });
      } else {
        timerId = setTimeout(reveal, idleDelay);
      }
    };
    if (document.readyState === "complete") {
      timerId = setTimeout(onLoad, idleDelay);
    } else {
      window.addEventListener("load", () => { timerId = setTimeout(onLoad, idleDelay); }, { once: true });
    }
    return () => {
      if (obs) obs.disconnect();
      if (idleId && "cancelIdleCallback" in window) window.cancelIdleCallback(idleId);
      if (timerId) clearTimeout(timerId);
    };
  }, [show, rootMargin, idleDelay]);

  if (show) return children;
  return <div ref={ref} id={placeholderId} style={{ minHeight }} aria-hidden="true" />;
}
